export const tableControlsKeyToHideOnHover = 'control-to-hide'
export const tableControlsKeyToShowOnHover = 'control-to-show'
